import { useTranslation } from 'react-i18next';
import {
  Checkbox,
  Flex,
  MenuProps,
  TableColumnType
} from "antd";
import { ChangeEvent, FunctionComponent, KeyboardEvent } from "react";

import {
  SearchOutlined
} from "@ant-design/icons";
import { CheckboxOptionType } from "antd/lib";
import FormInput from "../../../components/form-input/FormInput";
import { DataType } from "../../../types/listUsers";
import "./filter-table.scss";

type FilterTableProps = {
  handleOpen?: () => void;
  searchValue: string;
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void;
  handleSubmitSearch: () => void;
  handleOpenFilter: () => void;
  checkedList: Array<string>;
  setCheckedList: (value: string[]) => void;
  dataColumns: TableColumnType<DataType>[];
};

const FilterTable: FunctionComponent<FilterTableProps> = ({
  handleOpen,
  searchValue,
  handleChangeInput,
  handleSearch,
  handleSubmitSearch,
  handleOpenFilter,
  dataColumns,
  checkedList,
  setCheckedList,
}) => {
  const { t } = useTranslation();
  const options = dataColumns.map(({ key, title }) => ({
    label: title,
    value: key,
  }));

  const items: MenuProps["items"] = [
    {
      label: (
        <Checkbox.Group
          options={options as CheckboxOptionType[]}
          value={checkedList}
          onChange={(value) => {
            setCheckedList(value as string[]);
          }}
        />
      ),
      key: "radio",
    },
  ];

  const menuProps = {
    items,
  };

  return (
    <>
      <Flex>
        {/* <div className="heading-filter mr-4">
          <Button className="filter-button" onClick={handleOpenFilter}>
            <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
            <DownOutlined />
          </Button>
        </div> */}

        <div className="">
          <FormInput
            placeholder={t("Nhập tên hoặc mã khóa học cần tìm ", "Nhập tên hoặc mã khóa học cần tìm ")}
            value={searchValue}
            onChange={handleChangeInput}
            onKeyPress={handleSearch}
            afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
          />
        </div>
      </Flex>
    </>
  );
};

export default FilterTable;
